"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hash = exports.hashPins = void 0;
const node_object_hash_1 = require("node-object-hash");
const omit_deep_1 = require("./omit-deep");
function hashPins(pins) {
    return pins.map((pin) => ({ id: pin.id, hash: (0, exports.hash)(pin) }));
}
exports.hashPins = hashPins;
const sortingHasher = (0, node_object_hash_1.hasher)({
    sort: true, // ensure consistency of objects with different key order
    coerce: false, // strict value checking (no type coercion)
    alg: 'sha1', // faster implementation and good enough for this use case
    enc: 'base64', // encode the result to make it shorter
});
const hash = (obj) => {
    // we need to make sure to omit keys with undefined values before hashing, otherwise the hash will be different
    return sortingHasher.hash((0, omit_deep_1.omitDeepUndefined)(obj));
};
exports.hash = hash;
//# sourceMappingURL=pin-hashes.js.map